export enum AudioPlaybackType {
    PlayOnDevice = 0,
    PlayOnRemotePC = 1,
    NoSound = 2
}
